import { colors } from "../colors"

export const Divider = {
  baseStyle: {
    borderColor: colors.brand.border,
  },
}
